import { ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import ApexCharts from "apexcharts";

export default {
  name: "DashboardView",
  setup() {
    const router = useRouter();
    const totalCalls = ref(0);
    const totalMinutes = ref(0);
    const totalCost = ref(0.0);
    const selectedMonth = ref("");
    const fileName = ref("");
    const file = ref(null);
    const callTime = ref("");
    const fileInput = ref(null);
    const chart = ref(null);

    // Batch settings with defaults
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const defaultStart = `${yyyy}-${mm}-${dd}T09:00`;
    const defaultEnd = `${yyyy}-${mm}-${dd}T19:00`;

    const flow = ref('');
    const callServiceId = ref('');
    const credentialId = ref('');
    const startTimeBatch = ref(defaultStart);
    const endTimeBatch = ref(defaultEnd);
    const numberOfConnections = ref(1);
    const retryCount = ref(2);
    const retryInterval = ref(60);

    onMounted(async () => {
      // fetchStatus(company_name.value.toLowerCase()); // Initial fetch

      // Poll with fresh value every 10s
      setInterval(() => {
        // fetchStatus(company_name.value.toLowerCase());
      }, 10000);
    });

    const onFileChange = (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        file.value = selectedFile;
        fileName.value = selectedFile.name;
      }
    };

    const fetchStatistics = async () => {
      // Always use mock data - no API requests
      totalCalls.value = 1250;
      totalMinutes.value = 3420;
      totalCost.value = 342;

      // Mock daily data for the chart
      const mockDaily = [
        { date: '2025-07-01', successful_calls: 45 },
        { date: '2025-07-02', successful_calls: 67 },
        { date: '2025-07-03', successful_calls: 52 },
        { date: '2025-07-04', successful_calls: 78 },
        { date: '2025-07-05', successful_calls: 89 },
        { date: '2025-07-06', successful_calls: 65 },
        { date: '2025-07-07', successful_calls: 73 },
        { date: '2025-07-08', successful_calls: 91 },
        { date: '2025-07-09', successful_calls: 58 },
        { date: '2025-07-10', successful_calls: 82 },
        { date: '2025-07-11', successful_calls: 76 },
        { date: '2025-07-12', successful_calls: 94 },
        { date: '2025-07-13', successful_calls: 87 },
        { date: '2025-07-14', successful_calls: 69 },
        { date: '2025-07-15', successful_calls: 75 }
      ];

      const categories = mockDaily.map((d) => d.date.slice(5, 10));
      const counts = mockDaily.map((d) => d.successful_calls);

      // Update chart with mock data
      if (chart.value) {
        chart.value.updateOptions({
          series: [{ name: "Calls", data: counts }],
          xaxis: { categories },
        });
      }
    };

    const resetFile = () => {
      file.value = null;
      fileName.value = "";
      if (fileInput.value) {
        fileInput.value.value = null; // Reset the file input value
      }
    };

    const handleFileUpload = async () => {
      if (!file.value) {
        alert("Выберите файл для загрузки.");
        return;
      }

      // Simulate file upload success - no API requests
      console.log("File upload simulated successfully");
      alert("File uploaded successfully!");
      resetFile(); // Clear the file after successful upload
    };

    const goToCallDetails = () => {
      router.push("/call-details");
    };

    const logout = () => {
      localStorage.removeItem("token");
      router.push("/login");
    };

    const getUzbekistanTime = () => {
      const now = new Date();
      const uzbekistanTime = new Date(now.getTime() + 5 * 60 * 60 * 1000);
      const year = uzbekistanTime.getUTCFullYear();
      const month = String(uzbekistanTime.getUTCMonth() + 1).padStart(2, "0");
      const day = String(uzbekistanTime.getUTCDate()).padStart(2, "0");
      const hours = String(uzbekistanTime.getUTCHours()).padStart(2, "0");
      const minutes = String(uzbekistanTime.getUTCMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    onMounted(async () => {
      // Fetch initial statistics for the current month
      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();
      selectedMonth.value = `${year}-${month}`;
      await fetchStatistics();

      // Set current date and time in Uzbekistan as default value for callTime
      callTime.value = getUzbekistanTime();

      // Initialize ApexCharts
      var options = {
        chart: {
          type: "line",
          height: "45%",
        },
        series: [
          {
            name: "Number of Calls",
            data: [],
          },
        ],
        xaxis: {
          categories: [],
        },
        yaxis: {
          tickAmount: 5,
          max: 1000,
          labels: {
            formatter: (value) => value.toFixed(0),
          },
        },
      };

      chart.value = new ApexCharts(document.querySelector("#chart"), options);
      chart.value.render();
    });

    watch(selectedMonth, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        fetchStatistics();
      }
    });

    return {
      totalCalls,
      totalMinutes,
      totalCost,
      selectedMonth,
      fileName,
      callTime,
      file,
      fileInput,
      goToCallDetails,
      resetFile,
      logout,
      onFileChange,
      handleFileUpload,
      flow,
      callServiceId,
      credentialId,
      startTimeBatch,
      endTimeBatch,
      numberOfConnections,
      retryCount,
      retryInterval
    };
  },
};
